import { render, staticRenderFns } from "./OverviewPeople.vue?vue&type=template&id=7df93140&"
import script from "./OverviewPeople.vue?vue&type=script&lang=js&"
export * from "./OverviewPeople.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports